import { theme } from "aaa";
import * as React from "react";
import { ui } from "./uiHelpers";
export const TopBackgroundColor = (props: { color?: string }) => {
    const OVERSCROLL = 500;
    return (
        <>
            <div
                style={{
                    position: "fixed",
                    width: 1,
                    left: "50%",
                    height: 1,
                    backgroundColor: "rgba(0,0,0,0.1)"
                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: -OVERSCROLL,
                    left: 0,
                    right: 0,
                    height: 1 + OVERSCROLL,
                    background: props.color ?? theme.headerBackgroundColor(ui.isDarkMode)
                }}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/util/TopBackgroundColor.tsx